module.exports = __webpack_public_path__ + "static/media/beelogo.52e6f4e5.png";